import { render, staticRenderFns } from "./twoColumnBox.vue?vue&type=template&id=3b435928&"
import script from "./twoColumnBox.vue?vue&type=script&lang=js&"
export * from "./twoColumnBox.vue?vue&type=script&lang=js&"
import style0 from "./twoColumnBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports